export default __webpack_public_path__ + "static/media/left-login.b7f3abc4.svg";